import React, { useMemo } from "react";

import { useSelector } from "react-redux";

import { Body2 } from "Cobalt/BodyText";
import Button from "Cobalt/Button";
import { Table, TR, TD, SnugTD, NestedTR } from "Cobalt/TableV2";
import { formatEmployeeProfileAsInitialValues } from "Common/EnterAges/Components/Helpers/FormHelpers";
import { Div } from "Common/HTML";
import Icon from "Common/Icon";
import { SizeSwitch } from "Common/Responsive";

import makeBem from "Utils/makeBem";

const bem = makeBem("EnterAgesComponent");

const AddFamilyButton = () => {
  return (
    <Button className={bem("AddFamilyButton")} color="link" px={1}>
      <SizeSwitch xs="Family" sm="Add Family Member" />
    </Button>
  );
};

const RemoveButton = () => {
  return (
    <Button aria-label="Remove Employee" color="ghost" size="xs" circle>
      <Icon icon="times" flavor="regular" className={bem(null, "red")} />
    </Button>
  );
};

const EnterAgesTableBackgroundPlaceholder = ({ limit }) => {
  const openModal = useSelector((state) => state.openModal);
  const employeeProfile = useSelector((state) => state.employeeProfile);
  const employeeValues = useMemo(() => {
    return formatEmployeeProfileAsInitialValues(employeeProfile);
  }, [openModal]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <Table>
        <tbody>
          {employeeValues.slice(0, limit).map((employee, eeIndex) => {
            const { dependents } = employee;
            return (
              <React.Fragment key={eeIndex}>
                <TR withBorder={dependents.length === 0 && eeIndex < (limit || fields.length) - 1}>
                  <TD width="200px">
                    <Body2 htmlFor={employee.name} m={0} componentClass="label">
                      {employee.name}
                    </Body2>
                  </TD>
                  <SnugTD>
                    <div className={bem("AgeFormField")} />
                  </SnugTD>
                  <TD align="right">
                    <AddFamilyButton />
                  </TD>
                  <SnugTD>
                    <RemoveButton />
                  </SnugTD>
                </TR>
                {dependents.length > 0 &&
                  dependents.map((dep, depIndex) => (
                    <NestedTR key={`${dep.type}_${depIndex}`}>
                      <TD>
                        <Body2 htmlFor={dep.type} m={0} componentClass="label">
                          {dep.type}
                        </Body2>
                      </TD>
                      <SnugTD>
                        <div className={bem("AgeFormField")} />
                      </SnugTD>
                      <TD />
                      <SnugTD>
                        <RemoveButton />
                      </SnugTD>
                    </NestedTR>
                  ))}
              </React.Fragment>
            );
          })}
        </tbody>
      </Table>
      <Div>
        <Body2 className={bem(null, null)}>&nbsp;</Body2>
      </Div>
    </>
  );
};

export default EnterAgesTableBackgroundPlaceholder;
